import http from 'conversations-http/clients/http';
import { getFullUrl } from 'hubspot-url-utils';
import { workspaceNameToFileMapping } from '../constants/workspaceTypes';
export const fetchWorkspaceMinVersion = workspaceName => {
  return http.get(`${getFullUrl('app')}/inbox-version-check/${workspaceNameToFileMapping[workspaceName]}`);
};